module.exports = __webpack_public_path__ + "img/video_preview.ec984b19.jpg";